var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-file"
  }, [_c('b-modal', {
    attrs: {
      "id": "adduploadFile",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": "",
      "hide-header-close": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "adduploadFile-header text-center"
        }, [_c('h4', [_vm._v("Upload File")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "adduploadFile-form"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          ref: "addFileContainer",
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.addFile);
            }
          }
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true
            },
            "labelFor": "file_title",
            "labelName": "File Title",
            "inputName": "file_title",
            "vmodel": _vm.form.file_title,
            "formGroupClass": "form-group mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "file_title", $event);
            }
          }
        }), _c('input-multi-select', {
          attrs: {
            "vmodel": _vm.form.doc_type,
            "labelName": "FileType",
            "options": _vm.fileTypes.map(function (type) {
              return type.value;
            }),
            "custom-label": function customLabel(opt) {
              return _vm.fileTypes.find(function (x) {
                return x.value == opt;
              }).text;
            },
            "rules": {
              required: true
            },
            "formGroupClass": "form-group mb-3",
            "placeholder": "Select File Type"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "doc_type", $event);
            }
          }
        }), _c('input-file', {
          attrs: {
            "rules": {
              required: true,
              mimes: _vm.mimeTypes
            },
            "labelFor": "select_file",
            "labelName": "Select File (txt, png, jpg, jpeg, xlsx, pdf, csv, doc and pptx) ",
            "inputName": "select_file",
            "vmodel": _vm.file,
            "acceptMimeTypes": _vm.mimeTypes,
            "formGroupClass": "form-group mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              _vm.file = $event;
            }
          }
        }), _c('input-textarea', {
          attrs: {
            "rules": {
              required: true
            },
            "labelFor": "file",
            "labelName": "File Notes ",
            "inputName": "file",
            "vmodel": _vm.form.doc_notes,
            "formGroupClass": "form-group mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "doc_notes", $event);
            }
          }
        }), _c('div', {
          staticClass: "col-md-12"
        }, [_c('b-button', {
          staticClass: "upload-btn form-control",
          attrs: {
            "type": "submit",
            "disabled": _vm.isCreate
          }
        }, [_vm.isCreate ? [_vm._v(" Uploading ... ")] : [_vm._v(" Upload File ")]], 2)], 1)], 1)];
      }
    }])
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }